import {StyleSheet, View} from 'react-native';
import React from 'react';
import theme from '@/style';
import Text from '@/components/basic/text';
import ResultHeader from '@/common-pages/pick-digit/digit-tab/digit-result/result-header';
import LinearGradient from '@/components/basic/linear-gradient';
export interface TableHederProps {
  isQuick?: boolean;
  drawTime?: string;
}

const TableHeder = ({drawTime}: TableHederProps) => {
  return (
    <View style={[theme.overflow.hidden, styles.wrap]}>
      <LinearGradient
        colors={['#FFFFFF', 'rgba(255,255,255,0)']}
        style={[theme.padding.l, styles.titleRow]}>
        <Text
          accent
          fontSize={14}
          style={[theme.margin.rightxxs, styles.titleLabel]}>
          Lottery opening time:
        </Text>
        <Text
          size="medium"
          fontFamily="fontInterBold"
          color={theme.fontColor.second}
          style={styles.titleValue}>
          {drawTime}
        </Text>
      </LinearGradient>
      <ResultHeader />
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    borderTopLeftRadius: theme.paddingSize.s,
    borderTopRightRadius: theme.paddingSize.s,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleLabel: {
    fontWeight: '500',
  },
  titleValue: {
    lineHeight: 20,
  },
});

export default TableHeder;
